import * as apiTypes from '../../types/data-item-types';
export class SortStageImpl {
    constructor() {
        this.sortFields = [];
    }
    ascending(...fields) {
        fields.forEach((field) => {
            this.sortFields.push({ fieldName: field, order: apiTypes.SortOrder.ASC });
        });
        return this;
    }
    descending(...fields) {
        fields.forEach((field) => {
            this.sortFields.push({ fieldName: field, order: apiTypes.SortOrder.DESC });
        });
        return this;
    }
    toProto() {
        return { sort: { values: this.sortFields } };
    }
}
//# sourceMappingURL=SortStage.js.map